export default __webpack_public_path__ + "static/media/machine-learning-and-predictive-analytics.7e1016cb.png";